import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "text-sm text-gray-700" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-wrap items-center gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "px-6 py-4 text-sm text-red-600",
  role: "alert"
}

import { onMounted, ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import SettingCard from '@/components/settings/SettingCard.vue'
import SettingRow from '@/components/settings/SettingRow.vue'
import { HELP_URL } from '@/config/navSections'
import { appLabel } from '@/helpers/connectedApps'
import { connectedAppsApi } from '@/services/connectedAppsApi'

const DESCRIPTION = 'AI assistants you have given read-only access to your Bottle account.'
const EMPTY_HINT =
  'Connect Bottle to Claude or ChatGPT and ask about your drops, orders, revenue and prep from the assistant.'

const LOAD_ERROR = "Couldn't load your connected apps. Please refresh the page."
const DISCONNECT_ERROR = "Couldn't disconnect. Please try again."


export default {
  __name: 'ConnectedAppsCard',
  setup(__props) {

const connections = ref([])
const error = ref('')
const confirming = ref(null)
const busy = ref(null)

const formatDate = value => (value ? new Date(value).toLocaleDateString() : null)

const hintFor = connection => {
  const when = formatDate(connection.attributes.created_at)
  return when ? `Connected ${when}` : 'Connected'
}

const lastUsed = connection => {
  const when = formatDate(connection.attributes.last_used_at)
  return when ? `Last used ${when}` : 'Never used'
}

const load = async () => {
  try {
    connections.value = await connectedAppsApi.list()
  } catch (failure) {
    error.value = LOAD_ERROR
  }
}

const disconnect = async connection => {
  busy.value = connection.id
  error.value = ''
  try {
    await connectedAppsApi.disconnect(connection.id)
    connections.value = connections.value.filter(candidate => candidate.id !== connection.id)
    confirming.value = null
  } catch (failure) {
    error.value = DISCONNECT_ERROR
  } finally {
    busy.value = null
  }
}

onMounted(load)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingCard, {
    name: "Connected apps",
    description: DESCRIPTION
  }, {
    default: _withCtx(() => [
      (!connections.value.length && !error.value)
        ? (_openBlock(), _createBlock(SettingRow, {
            key: 0,
            label: "Nothing connected yet",
            hint: EMPTY_HINT
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(HELP_URL),
                target: "_blank",
                rel: "noopener",
                class: "text-sm font-medium text-brand-600 hover:text-brand-700"
              }, " Visit the help centre ", 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connections.value, (connection) => {
        return (_openBlock(), _createBlock(SettingRow, {
          key: connection.id,
          label: _unref(appLabel)(connection),
          hint: hintFor(connection)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(lastUsed(connection)), 1),
              (confirming.value !== connection.id)
                ? (_openBlock(), _createBlock(NeueButton, {
                    key: 0,
                    type: "secondary",
                    onClick: $event => (confirming.value = connection.id)
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" Disconnect ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(NeueButton, {
                      type: "secondary",
                      onClick: _cache[0] || (_cache[0] = $event => (confirming.value = null))
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Keep connected", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(NeueButton, {
                      type: "red",
                      loading: busy.value === connection.id,
                      onClick: $event => (disconnect(connection))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Disconnect " + _toDisplayString(_unref(appLabel)(connection)), 1)
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick"])
                  ]))
            ])
          ]),
          _: 2
        }, 1032, ["label", "hint"]))
      }), 128)),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}